import { FormInstance } from 'antd';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { sumFieldForParent } from '../../gantChangeData';
import { RootState } from '../../store';
import { ItemType, MappingItemIdIndexType } from '../../types';

const useControlOtherFields = (
    form: FormInstance,
    values: ItemType,
    bufferItems: React.MutableRefObject<ItemType[]>,
    saveBufferToStore: () => void,
    updatedItem?: ItemType,
    filterFields?: (keyof ItemType)[],
) => {
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const isDragging = useSelector<RootState, boolean>((state) => state.gantDraggable.isDragging);
    const interestedFields = new Set(filterFields);

    useEffect(() => {
        if (!updatedItem || !values || isDragging || !bufferItems.current.length) {
            return;
        }

        // field name is dynamic field and locate to another form but that use this controller
        // and if user doesn't edit name than 'values' doesn't include data from field name
        // to avoid error add value manually to 'values'
        if (!values.name) {
            values.name = updatedItem.name;
        }

        const previousItem = bufferItems.current[mappingItemIdIndex[updatedItem.id]];

        const fields: (keyof ItemType)[] = [
            'name',
            'color',
            'phaseId',
            'costCodeId',
            'divisionId',
            'priority',
            'type',
            'status',
            'contractInvoice',
            'description',
            'countHours',
            'countDays',
            'countPeople',
            'countTools',
            'equipmentHours',
            'materialHours',
            'valueEquipment',
            'valueLabour',
            'woSi',
            'valueMaterial',
            'valueOther',
            'valueTotal',
            'countMaterial',
            'assignee',
            'ownerItemId',
        ].filter(
            (field) => interestedFields.size === 0 || interestedFields.has(field as keyof ItemType),
        ) as (keyof ItemType)[];

        const fieldsNumber = [
            'phaseId',
            'costCodeId',
            'divisionId',
            'priority',
            'type',
            'status',
            'countHours',
            'countDays',
            'countPeople',
            'countTools',
            'equipmentHours',
            'materialHours',
            'valueEquipment',
            'valueLabour',
            'valueMaterial',
            'valueOther',
            'valueTotal',
            'countMaterial',
        ].filter(
            (field) => interestedFields.size === 0 || interestedFields.has(field as keyof ItemType),
        ) as (keyof ItemType)[];

        const partItem: { [key: string]: any } = {};

        for (const field of fields) {
            partItem[field] = values[field] || null;
        }

        for (const field of fieldsNumber) {
            partItem[field] = values[field] ? +values[field]! : null;
        }

        const checkFields = () => {
            for (const field of fields) {
                if (partItem[field] !== previousItem[field]) {
                    return false;
                }
            }
            return true;
        };

        if (values.projectId === previousItem.projectId && checkFields()) {
            return;
        }

        bufferItems.current = [...bufferItems.current];
        bufferItems.current[mappingItemIdIndex[updatedItem.id]] = {
            ...previousItem,
            projectId: updatedItem.roleItem === 'project' ? updatedItem.projectId : values.projectId,
            ...partItem,
        } as ItemType;

        if (values.parentId) {
            bufferItems.current = sumFieldForParent(mappingItemIdIndex, values.parentId, bufferItems.current);
        }

        saveBufferToStore();
    }, [values]);

    return [];
};

export default useControlOtherFields;
